import { LazyQueryExecFunction, OperationVariables } from '@apollo/client'

import { InputData, LogsData } from '../../../types/auditLogs'
import AuditLogsFormListRowDesktop from './AuditLogsFormListRowDesktop'
import AuditLogsFormListRowSkeleton from './AuditLogsFormListRowSkeleton.skeleton'
import AuditLogsFormListTableHeadDesktop from './AuditLogsFormListTableHeadDesktop'
import useStyles from './styles/AuditLogsFormList'

interface AuditLogsFormListDesktopProps {
  data: LogsData | undefined
  loadingForAuditLogs: boolean
  getAuditLogsData: LazyQueryExecFunction<
    {
      auditLogs: LogsData
    },
    OperationVariables
  >
  inputData: InputData
  setInputData: React.Dispatch<React.SetStateAction<InputData>>
  setPage: React.Dispatch<React.SetStateAction<number>>
  actionNames: {
    label: string
    value: string
  }[]
  newLogsCount: number
  isRoleAdmin: boolean
}

const AuditLogsFormListDesktop: React.FC<AuditLogsFormListDesktopProps> = ({
  data,
  loadingForAuditLogs,
  getAuditLogsData,
  inputData,
  setInputData,
  setPage,
  actionNames,
  newLogsCount,
  isRoleAdmin
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <AuditLogsFormListTableHeadDesktop
        getAuditLogsData={getAuditLogsData}
        inputData={inputData}
        setInputData={setInputData}
        setPage={setPage}
        newLogsCount={newLogsCount}
        isRoleAdmin={isRoleAdmin}
      />
      {!loadingForAuditLogs
        ? data?.logs.map((eachRow, index) => (
            <AuditLogsFormListRowDesktop
              key={index}
              data={eachRow}
              actionNames={actionNames}
              isRoleAdmin={isRoleAdmin}
            />
          ))
        : Array(10)
            .fill(' ')
            .map((_, index) => (
              <AuditLogsFormListRowSkeleton
                key={index}
                isRoleAdmin={isRoleAdmin}
              />
            ))}
    </div>
  )
}
export default AuditLogsFormListDesktop
